import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const ImageModal = ({ isOpen, onClose, image }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen || !image) return null;

  const isVideo = image.type === 'video' || image.src?.includes('.mp4');

  return (
    <div
      className={`modal-overlay ${isOpen ? 'active' : ''}`}
      id="imageModal"
      onClick={onClose}
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>

        {/* Left: Image or Video */}
        <div className="modal-image-container">
          {isVideo ? (
            <video
              id="modalVideo"
              src={image.src}
              controls
              autoPlay
              loop
              className="modal-video"
            />
          ) : (
            <img id="modalImage" src={image.src} alt={image.alt} />
          )}
        </div>

        {/* Right: Details */}
        <div className="modal-info" id="modalInfo">
          <div className="modal-info-section">
            <div className="modal-info-label">
              {isVideo ? 'Video Format' : 'Aspect Ratio'}
            </div>
            <div className="modal-info-value">{image.ratio}</div>
          </div>
          
          {isVideo ? (
            <>
              <div className="modal-info-section">
                <div className="modal-info-label">AI Model</div>
                <div className="modal-info-prompt">{image.model}</div>
              </div>
              <div className="modal-info-section">
                <div className="modal-info-label">Tools Used</div>
                <div className="modal-info-prompt">{image.tools}</div>
              </div>
              <div className="modal-info-section">
                <div className="modal-info-label">Approach</div>
                <div className="modal-info-prompt">{image.approach}</div>
              </div>
            </>
          ) : (
            <div className="modal-info-section">
              <div className="modal-info-label">AI Prompt</div>
              <div className="modal-info-prompt">{image.prompt}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ImageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    ratio: PropTypes.string.isRequired,
    prompt: PropTypes.string,
    model: PropTypes.string,
    tools: PropTypes.string,
    approach: PropTypes.string,
    type: PropTypes.string,
  }),
};

export default ImageModal;